"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var restful_model_1 = __importDefault(require("./restful-model"));
var attributes_1 = __importDefault(require("./attributes"));
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar(connection, props) {
        var _this = _super.call(this, connection, props) || this;
        _this.name = '';
        _this.description = '';
        _this.location = '';
        _this.timezone = '';
        _this.initAttributes(props);
        return _this;
    }
    Calendar.prototype.save = function (params, callback) {
        if (params === void 0) { params = {}; }
        return _super.prototype.save.call(this, params, callback);
    };
    Calendar.prototype.saveRequestBody = function () {
        var calendarJSON = _super.prototype.saveRequestBody.call(this);
        return {
            name: calendarJSON.name,
            description: calendarJSON.description,
            location: calendarJSON.location,
            timezone: calendarJSON.timezone,
            metadata: calendarJSON.metadata,
        };
    };
    Calendar.prototype.getJobStatus = function (callback) {
        if (typeof this.jobStatusId === 'undefined') {
            var err = new Error('jobStatusId must be defined');
            if (callback) {
                callback(err);
            }
            return Promise.reject(err);
        }
        return this.connection.jobStatuses.find(this.jobStatusId, callback);
    };
    Calendar.collectionName = 'calendars';
    Calendar.attributes = __assign(__assign({}, restful_model_1.default.attributes), { name: attributes_1.default.String({
            modelKey: 'name',
        }), description: attributes_1.default.String({
            modelKey: 'description',
        }), readOnly: attributes_1.default.Boolean({
            modelKey: 'readOnly',
            jsonKey: 'read_only',
            readOnly: true,
        }), location: attributes_1.default.String({
            modelKey: 'location',
        }), timezone: attributes_1.default.String({
            modelKey: 'timezone',
        }), isPrimary: attributes_1.default.Boolean({
            modelKey: 'isPrimary',
            jsonKey: 'is_primary',
            readOnly: true,
        }), jobStatusId: attributes_1.default.String({
            modelKey: 'jobStatusId',
            jsonKey: 'job_status_id',
            readOnly: true,
        }), metadata: attributes_1.default.Object({
            modelKey: 'metadata',
        }) });
    return Calendar;
}(restful_model_1.default));
exports.default = Calendar;
